import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBasicBusinessInfoView } from '../../api/ReportsAPI/basicBusinessInfoAPI';

export const fetchBasicBusinessInfo = createAsyncThunk(
    'basicBusinessInfo/fetch',
    async (_, { rejectWithValue }) => {
        try {
            const res = await getBasicBusinessInfoView();
            return res?.Data || null;
        } catch (err) {
            return rejectWithValue(err?.Message || err?.message || 'Failed to load business info');
        }
    }
);

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const basicBusinessInfoSlice = createSlice({
    name: 'basicBusinessInfo',
    initialState,
    reducers: {
        resetBasicBusinessInfo: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBasicBusinessInfo.pending, (s) => { s.loading = true; s.error = null; })
            .addCase(fetchBasicBusinessInfo.fulfilled, (s, a) => { s.loading = false; s.data = a.payload; })
            .addCase(fetchBasicBusinessInfo.rejected, (s, a) => { s.loading = false; s.error = a.payload; });
    },
});

export const { resetBasicBusinessInfo } = basicBusinessInfoSlice.actions;

export const selectBasicBusinessInfoData    = (s) => s.basicBusinessInfo.data;
export const selectBasicBusinessInfoLoading = (s) => s.basicBusinessInfo.loading;
export const selectBasicBusinessInfoError   = (s) => s.basicBusinessInfo.error;

export default basicBusinessInfoSlice.reducer;
